import axioshttp from '@/config/httpConfig'


//////申報後台////////

//ThreadingAircraft
export function ThreadingAircraft(data) {
  return axioshttp.post('/api/v1/BackEndThread/ThreadingAircraft', 'BackEndService', data);
}

//ThreadingBuilding
export function ThreadingBuilding(data) {
  return axioshttp.post('/api/v1/BackEndThread/ThreadingBuilding', 'BackEndService', data);
}

//ThreadingDebt
export function ThreadingDebt(data) {
  return axioshttp.post('/api/v1/BackEndThread/ThreadingDebt', 'BackEndService', data);
}

//ThreadingDeposit
export function ThreadingDeposit(data) {
  return axioshttp.post('/api/v1/BackEndThread/ThreadingDeposit', 'BackEndService', data);
}

//ThreadingFiabow
export function ThreadingFiabow(data) {
  return axioshttp.post('/api/v1/BackEndThread/ThreadingFiabow', 'BackEndService', data);
}

//ThreadingInsurance
export function ThreadingInsurance(data) {
  return axioshttp.post('/api/v1/BackEndThread/ThreadingInsurance', 'BackEndService', data);
}

//ThreadingLand
export function ThreadingLand(data) {
  return axioshttp.post('/api/v1/BackEndThread/ThreadingLand', 'BackEndService', data);
}

//ThreadingMarginTrading
export function ThreadingMarginTrading(data) {
  return axioshttp.post('/api/v1/BackEndThread/ThreadingMarginTrading', 'BackEndService', data);
}

//ThreadingMarketableSecurities
export function ThreadingMarketableSecurities(data) {
  return axioshttp.post('/api/v1/BackEndThread/ThreadingMarketableSecurities', 'BackEndService', data);
}

//ThreadingInvestment
export function ThreadingInvestment(data) {
  return axioshttp.post('/api/v1/BackEndThread/ThreadingInvestment', 'BackEndService', data);
}

//ThreadingOtherProperties
export function ThreadingOtherProperties(data) {
  return axioshttp.post('/api/v1/BackEndThread/ThreadingOtherProperties', 'BackEndService', data);
}

//ThreadingVehicle
export function ThreadingVehicle(data) {
  return axioshttp.post('/api/v1/BackEndThread/ThreadingVehicle', 'BackEndService', data);
}

//ThreadingVessel
export function ThreadingVessel(data) {
  return axioshttp.post('/api/v1/BackEndThread/ThreadingVessel', 'BackEndService', data);
}

//ThreadingTrustLand
export function ThreadingTrustLand(data) {
  return axioshttp.post('/api/v1/BackEndThread/ThreadingTrustLand', 'BackEndService', data);
}

//ThreadingTrustBuilding
export function ThreadingTrustBuilding(data) {
  return axioshttp.post('/api/v1/BackEndThread/ThreadingTrustBuilding', 'BackEndService', data);
}

//ThreadingTrustStock
export function ThreadingTrustStock(data) {
  return axioshttp.post('/api/v1/BackEndThread/ThreadingTrustStock', 'BackEndService', data);
}

//ThreadingExchangeStock
export function ThreadingExchangeStock(data) {
  return axioshttp.post('/api/v1/BackEndThread/ThreadingExchangeStock', 'BackEndService', data);
}


//GetCodeMain
export function GetCodeMain(data) {
  return axioshttp.post('/api/v1/DataTransfer/GetCodeMain', 'BackEndService', data);
}


//GetLandDropDownMenu
export function GetLandDropDownMenu(data) {
  return axioshttp.get('/api/v1/BackEndReportingForm/GetLandDropDownMenu', 'BackEndService', data);
}

//GetBuildingDropDownMenu
export function GetBuildingDropDownMenu(data) {
  return axioshttp.get('/api/v1/BackEndReportingForm/GetBuildingDropDownMenu', 'BackEndService', data);
}

//GetVesselDropDownMenu
export function GetVesselDropDownMenu(data) {
  return axioshttp.get('/api/v1/BackEndReportingForm/GetVesselDropDownMenu', 'BackEndService', data);
}

//GetVehicleDropDownMenu
export function GetVehicleDropDownMenu(data) {
  return axioshttp.get('/api/v1/BackEndReportingForm/GetVehicleDropDownMenu', 'BackEndService', data);
}

//GetAircraftDropDownMenu
export function GetAircraftDropDownMenu(data) {
  return axioshttp.get('/api/v1/BackEndReportingForm/GetAircraftDropDownMenu', 'BackEndService', data);
}

//GetCurrencyDropDownMenu
export function GetCurrencyDropDownMenu(data) {
  return axioshttp.get('/api/v1/BackEndReportingForm/GetCashDropDownMenu', 'BackEndService', data);
}

//GetDepositDropDownMenu
export function GetDepositDropDownMenu(data) {
  return axioshttp.get('/api/v1/BackEndReportingForm/GetDepositDropDownMenu', 'BackEndService', data);
}

//GetSecuritiesDropDownMenu
export function GetSecuritiesDropDownMenu(data) {
  return axioshttp.get('/api/v1/BackEndReportingForm/GetSecuritiesDropDownMenu', 'BackEndService', data);
}

//GetInsuranceDropDownMenu
export function GetInsuranceDropDownMenu(data) {
  return axioshttp.get('/api/v1/BackEndReportingForm/GetInsuranceDropDownMenu', 'BackEndService', data);
}

//GetDebtDropDownMenu
export function GetDebtDropDownMenu(data) {
  return axioshttp.get('/api/v1/BackEndReportingForm/GetDebtDropDownMenu', 'BackEndService', data);
}


//申報結果查詢
export function SearchApplyResults(data) {
  return axioshttp.post('/api/v1/BackEnd/SearchApplyResults', 'BackEndService', data);
}

//列印申報收據
export function PrintApplyResults(data) {
  return axioshttp.post('/api/v1/BackEnd/PrintApplyResults', 'BackEndService', data);
}

//監察院財產資料授權查詢
export function SearchPropertyAuthorizeResults(data) {
  return axioshttp.post('/api/v1/BackEnd/SearchPropertyAuthorizeResults', 'BackEndService', data);
}

//PrintPdisReport
export function PrintPdisReport(data) {
  return axioshttp.post('/api/v1/BackEndReportingForm/PrintPdisReport', 'BackEndService', data);
}
//PrintPdisHideReport
export function PrintPdisHideReport(data) {
  return axioshttp.post('/api/v1/BackEndReportingForm/PrintPdisHideReport', 'BackEndService', data);
}


//PrintReport
export function PrintReport(data) {
  return axioshttp.post('/api/v1/BackEndReportingForm/PrintReport', 'BackEndService', data);
}

//////申報前台////////

//取得公告事項
export function GetNotice(data) {
  return axioshttp.post('/api/v1/Base/GetNotice', 'BackstageApi', data);
}

//取得公告事項明細
export function GetNoticeDetail(data) {
  return axioshttp.post('/api/v1/Base/GetNoticeDetail', 'BackstageApi', data);
}

//////管理後台////////

//取得角色程式清單
export function GetRoleAuthorizeMenu(data) {
  return axioshttp.post('/api/v1/Base/GetRoleAuthorizeMenu', 'BackstageApi', data);
}

//取得GoveCode
export function SearchGovCode(data) {
  return axioshttp.post('/api/v1/Base/SearchGovCode', 'BackstageApi', data);
}
//取得RGoveCode
export function SearchRGovCode(data) {
  return axioshttp.post('/api/v1/Base/SearchRGovCode', 'BackstageApi', data);
}


//取得onJob
export function SearchGridOnJob(data) {
  return axioshttp.post('/api/v1/PDISA1031F/SearchGridOnJob', 'BackstageApi', data);
}

//取得申報身分資格
export function SearchGridOnDeclare(data) {
  return axioshttp.post('/api/v1/Base/SearchGridOnDeclare', 'BackstageApi', data);
}

//管理平台登入
export function BackstageApiLogin(data) {
  return axioshttp.post('/api/v1/Base/Login', 'BackstageApi', data);
}

//取得首頁資訊
export function Index_SearchGrid(data) {
  return axioshttp.post('/api/v1/Index/SearchGrid', 'BackstageApi', data);
}

//A101查詢
export function A101_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISA101F/SearchGrid', 'BackstageApi', data);
}
export function A101_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISA101F/ReSearchGrid', 'BackstageApi', data);
}

//A101 匯入
export function A101_Import(data) {
  return axioshttp.post('/api/v1/PDISA101F/Import', 'BackstageApi', data);
}

//A101 匯出
export function A101_PrintReport(data) {
  return axioshttp.post('/api/v1/PDISA101F/PrintReport', 'BackstageApi', data);
}

//A101 明細
export function A101_Detail(data) {
  return axioshttp.post('/api/v1/PDISA101F/Detail', 'BackstageApi', data);
}

//A101 明細(不編輯)
export function A101_DetailInit(data) {
  return axioshttp.post('/api/v1/PDISA101F/DetailInit', 'BackstageApi', data);
}

//A101 明細新增
export function A101_DetailAddSave(data) {
  return axioshttp.post('/api/v1/PDISA101F/DetailAddSave', 'BackstageApi', data);
}

//A101 明細修改
export function A101_DetailEditSave(data) {
  return axioshttp.post('/api/v1/PDISA101F/DetailEditSave', 'BackstageApi', data);
}

//A101 明細服務機關變動查詢
export function A101_SearchLog(data) {
  return axioshttp.post('/api/v1/PDISA101F/SearchLog', 'BackstageApi', data);
}

//A101 服務機關變動
export function A101_GovCodeEditSave(data) {
  return axioshttp.post('/api/v1/PDISA101F/GovCodeEditSave', 'BackstageApi', data);
}

//A101第一頁刪除
export function A101_Delete(data) {
  return axioshttp.post('/api/v1/PDISA101F/Delete', 'BackstageApi', data);
}

//A103查詢
export function A103_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISA1031F/SearchGrid', 'BackstageApi', data);
}
export function A103_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISA1031F/ReSearchGrid', 'BackstageApi', data);
}

//A103整批移轉
export function A103_Trans(data) {
  return axioshttp.post('/api/v1/PDISA1031F/Trans', 'BackstageApi', data);
}

//B101查詢
export function B101_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISB101F/SearchGrid', 'BackstageApi', data);
}
export function B101_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISB101F/ReSearchGrid', 'BackstageApi', data);
}

//B101明細查詢
export function B101_SearchGridDetail(data) {
  return axioshttp.post('/api/v1/PDISB101F/SearchGridDetail', 'BackstageApi', data);
}
//B101 下載紙本上傳
export function B101_UploadReport(data) {
  return axioshttp.post('/api/v1/PDISB101F/UploadReport', 'BackstageApi', data);
}

//B102查詢
export function B102_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISB1021F/SearchGrid', 'BackstageApi', data);
}

//B102查詢
export function B102_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISB1021F/ReSearchGrid', 'BackstageApi', data);
}

//B102紙本記錄查詢
export function B102_SearchGridMain(data) {
  return axioshttp.post('/api/v1/PDISB1021F/SearchGridMain', 'BackstageApi', data);
}

//B102 第二頁編按鈕
export function B102_DetailAdd(data) {
  return axioshttp.post('/api/v1/PDISB1021F/DetailAdd', 'BackstageApi', data);
}
//B102 第二頁找家人
export function B102_DetailFamily(data) {
  return axioshttp.post('/api/v1/PDISB1021F/DetailFamily', 'BackstageApi', data);
}
//B102 明細新增
export function B102_DetailAddSave(data) {
  return axioshttp.post('/api/v1/PDISB1021F/DetailAddSave', 'BackstageApi', data);
}

//B102 明細修改
export function B102_DetailEditSave(data) {
  return axioshttp.post('/api/v1/PDISB1021F/DetailEditSave', 'BackstageApi', data);
}

//B103 查詢
export function B103_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISB1031F/SearchGrid', 'BackstageApi', data);
}
export function B103_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISB1031F/ReSearchGrid', 'BackstageApi', data);
}

//B103 列印
export function B103_print(data) {
  return axioshttp.post('/api/v1/PDISB1031F/Print', 'BackstageApi', data);
}

//B104查詢
export function B104_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISB104F/SearchGrid', 'BackstageApi', data);
}
export function B104_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISB104F/ReSearchGrid', 'BackstageApi', data);
}


//B104明細查詢
export function B104_SearchGridDetail(data) {
  return axioshttp.post('/api/v1/PDISB104F/SearchGridDetail', 'BackstageApi', data);
}

//B105查詢
export function B105_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISB105F/SearchGrid', 'BackstageApi', data);
}
export function B105_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISB105F/ReSearchGrid', 'BackstageApi', data);
}

//B105申報人數計算
export function B105_CountTotal(data) {
  return axioshttp.post('/api/v1/PDISB105F/CountTotal', 'BackstageApi', data);
}

//B105 各機關申報狀態查詢-基本資料
export function B105_Detail(data) {
  return axioshttp.post('/api/v1/PDISB105F/Detail', 'BackstageApi', data);
}

//B105 各機關申報狀態查詢-基本資料新增
export function B105_DetailAddSave(data) {
  return axioshttp.post('/api/v1/PDISB105F/DetailAddSave', 'BackstageApi', data);
}

//B105 各機關申報狀態查詢-基本資料修改
export function B105_DetailEditSave(data) {
  return axioshttp.post('/api/v1/PDISB105F/DetailEditSave', 'BackstageApi', data);
}

//D106 公職人員抽籤名單名單
export function D106_Print(data) {
  return axioshttp.post('/api/v1/PDISD106R/Print', 'BackstageApi', data);
}
//D107 年度公職人員財產申報人數及抽查比例統計表
export function D107_Print(data) {
  return axioshttp.post('/api/v1/PDISD107R/Print', 'BackstageApi', data);
}
//D110 自然人憑證使用次數統計表
export function D110_Print(data) {
  return axioshttp.post('/api/v1/PDISD110R/Print', 'BackstageApi', data);
}
//D111 列印授權狀況
export function D111_Print(data) {
  return axioshttp.post('/api/v1/PDISD111R/PrintPdisD111R', 'BackstageApi', data);
}


//F101受理機關
export function F101_init(data) {
  return axioshttp.post('/api/v1/PDISF1011F/Init1', 'BackstageApi', data);
}

//F101抽籤
export function F101_Drawlots(data) {
  return axioshttp.post('/api/v1/PDISF1011F/Drawlots', 'BackstageApi', data);
}
//F101再次抽籤
export function F101_ReDrawlots(data) {
  return axioshttp.post('/api/v1/PDISF1011F/ReDrawlots', 'BackstageApi', data);
}

//F101 統計參與抽籤人數
export function F101_Lotcount(data) {
  return axioshttp.post('/api/v1/PDISF1011F/Lotcount', 'BackstageApi', data);
}

//F101 瀏覽參與抽籤人員名單
export function F101_LotFindList(data) {
  return axioshttp.post('/api/v1/PDISF1011F/LotFindList', 'BackstageApi', data);
}

//F102 查詢
export function F102_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISF1021F/SearchGrid', 'BackstageApi', data);
}

//F102 存檔
export function F102_DetailEditSave(data) {
  return axioshttp.post('/api/v1/PDISF1021F/DetailEditSave', 'BackstageApi', data);
}

export function F102_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISF1021F/ReSearchGrid', 'BackstageApi', data);
}

//F102 匯出中籤名單
export function F102_PrintReport(data) {
  return axioshttp.post('/api/v1/PDISF1021F/PrintReport', 'BackstageApi', data);
}
//F102 刪除
export function F102_Delete(data) {
  return axioshttp.post('/api/v1/PDISF1021F/Delete', 'BackstageApi', data);
}
//F102 新增中籤名單
export function F102_DetailAddSave(data) {
  return axioshttp.post('/api/v1/PDISF1021F/DetailAddSave', 'BackstageApi', data);
}
//F102 送至M101審查
export function F102_SendToM101(data) {
  return axioshttp.post('/api/v1/PDISF1021F/SendToM101', 'BackstageApi', data);
}

//F103查詢
export function F103_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISF1031F/SearchGrid', 'BackstageApi', data);
}
export function F103_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISF1031F/ReSearchGrid', 'BackstageApi', data);
}

//F104匯入
export function F104_Import(data) {
  return axioshttp.post('/api/v1/PDISF1041F/Import', 'BackstageApi', data);
}

//F105查詢
export function F105_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISF1051F/SearchGrid', 'BackstageApi', data);
}
export function F105_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISF1051F/ReSearchGrid', 'BackstageApi', data);
}

//F105上傳筆數
export function F105_SearchCount(data) {
  // return axioshttp.post('/api/v1/PDISF1051F/SearchCount', 'BackstageApi' , data);
  return axioshttp.post('/api/v1/PDISF1051F/PrintCountReport', 'BackstageApi', data);
}

//F105產製抽籤名單
export function F105_SearchTeam(data) {
  return axioshttp.post('/api/v1/PDISF1051F/SearchTeam', 'BackstageApi', data);
}
//F105匯入
export function F105_ImportCheck(data) {
  return axioshttp.post('/api/v1/PDISF1051F/ImportCheck', 'BackstageApi', data);
}
//F105匯入
export function F105_Import(data) {
  return axioshttp.post('/api/v1/PDISF1051F/Import', 'BackstageApi', data);
}
//F105匯入暫存
export function F105_ImportTemp(data) {
  return axioshttp.post('/api/v1/PDISF1051F/ImportTemp', 'BackstageApi', data);
}
//F105確認匯入
export function F105_ImportSubmit(data) {
  return axioshttp.post('/api/v1/PDISF1051F/ImportSubmit', 'BackstageApi', data);
}

//F105匯出 列印產製抽籤名單
export function F105_PrintReport(data) {
  return axioshttp.post('/api/v1/PDISF1051F/PrintReport', 'BackstageApi', data);
}
//F105刪除
export function F105_Delete(data) {
  return axioshttp.post('/api/v1/PDISF1051F/Delete', 'BackstageApi', data);
}

//F106查詢
export function F106_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISF1061F/SearchGrid', 'BackstageApi', data);
}
export function F106_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISF1061F/ReSearchGrid', 'BackstageApi', data);
}
//F106匯入
export function F106_Import(data) {
  return axioshttp.post('/api/v1/PDISF1061F/Import', 'BackstageApi', data);
}
//F201 第一頁查詢
export function F201_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISN1011F/SearchGrid', 'BackstageApi', data);
}
export function F201_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISN1011F/ReSearchGrid', 'BackstageApi', data);
}

//F201 第一頁查核比對結果
export function F201_SearchGrid2(data) {
  return axioshttp.post('/api/v1/PDISN1011F/SearchN1012FGrid', 'BackstageApi', data);
}

//F201 第一頁列印審核結果_Docx
export function F201_printVerifyResult_Docx(data) {
  return axioshttp.post('/api/v1/PDISN1011F/printVerifyResult_Docx', 'BackstageApi', data);
}

//F201 第一頁列印審核不符結果_Docx
export function F201_printVerifyNoMatchResult_Docx(data) {
  return axioshttp.post('/api/v1/PDISN1011F/printVerifyNoMatchResult_Docx', 'BackstageApi', data);
}

//F201 第一頁更新審核結果
export function F201_updateVerifyResult(data) {
  return axioshttp.post('/api/v1/PDISN1011F/updateVerifyResult', 'BackstageApi', data);
}

export function F201_searchText2Object(data){
  return axioshttp.post('/api/v1/PDISN1011F/searchText2Object', 'BackstageApi', data);
}

//F201 第一頁配對
export function F201_matchVerifyResult(data) {
  return axioshttp.post('/api/v1/PDISN1011F/matchVerifyResult', 'BackstageApi', data);
}
//F201 第二頁個財產回朔
export function F201_mappingData(data) {
  return axioshttp.post('/api/v1/PDISN1011F/mappingData', 'BackstageApi', data);
}

//F201 第三頁更新土地編輯內容查核資料
export function F201_updateVerifyLandData(data) {
  return axioshttp.post('/api/v1/PDISN1011F/updateVerifyLandData', 'BackstageApi', data);
}
//F201 第三頁更新建物編輯內容查核資料
export function F201_updateVerifyBuildingData(data) {
  return axioshttp.post('/api/v1/PDISN1011F/updateVerifyBuildingData', 'BackstageApi', data);
}
//F201 第三頁更新船舶編輯內容查核資料
export function F201_updateVerifyVesselData(data) {
  return axioshttp.post('/api/v1/PDISN1011F/updateVerifyVesselData', 'BackstageApi', data);
}
//F201 第三頁更新汽車編輯內容查核資料
export function F201_updateVerifyVehicleData(data) {
  return axioshttp.post('/api/v1/PDISN1011F/updateVerifyVehicleData', 'BackstageApi', data);
}
//F201 第三頁更新航空器編輯內容查核資料
export function F201_updateVerifyAircraftData(data) {
  return axioshttp.post('/api/v1/PDISN1011F/updateVerifyAircraftData', 'BackstageApi', data);
}
//F201 第三頁更新現金編輯內容查核資料
export function F201_updateVerifyCurrencyData(data){
  return axioshttp.post('/api/v1/PDISN1011F/updateVerifyCurrencyData', 'BackstageApi' , data);
}
//F201 第三頁更新存款編輯內容查核資料
export function F201_updateVerifyDepositData(data) {
  return axioshttp.post('/api/v1/PDISN1011F/updateVerifyDepositData', 'BackstageApi', data);
}
//F201 第三頁更新有價證券(股票)編輯內容查核資料
export function F201_updateVerifyStockData(data) {
  return axioshttp.post('/api/v1/PDISN1011F/updateVerifyStockBond1Data', 'BackstageApi', data);
}
//F201 第三頁更新有價證券(票券，債券，其他有價證券)編輯內容查核資料
export function F201_updateVerifyBondValuePaperData(data) {
  return axioshttp.post('/api/v1/PDISN1011F/updateVerifyStockBond2Data', 'BackstageApi', data);
}
//F201 第三頁更新有價證券(基金受益憑證)編輯內容查核資料
export function F201_updateVerifyFundData(data) {
  return axioshttp.post('/api/v1/PDISN1011F/updateVerifyStockBond3Data', 'BackstageApi', data);
}
//F201 第三頁更新其他財產編輯內容查核資料
export function F201_updateVerifyOtherPropertyData(data) {
  return axioshttp.post('/api/v1/PDISN1011F/updateVerifyOtherPropertyData', 'BackstageApi', data);
}

//F201 第三頁更新保險編輯內容查核資料
export function F201_updateVerifyInsuranceData(data) {
  return axioshttp.post('/api/v1/PDISN1011F/updateVerifyInsuranceData', 'BackstageApi', data);
}
//F201 第三頁更新債權編輯內容查核資料
export function F201_updateVerifyClaimData(data) {
  return axioshttp.post('/api/v1/PDISN1011F/updateVerifyClaimData', 'BackstageApi', data);
}

//F201 第三頁更新債務編輯內容查核資料
export function F201_updateVerifyDebtData(data) {
  return axioshttp.post('/api/v1/PDISN1011F/updateVerifyDebtData', 'BackstageApi', data);
}

//F201 第三頁更新事業投資編輯內容查核資料
export function F201_updateVerifyInvestmentData(data) {
  return axioshttp.post('/api/v1/PDISN1011F/updateVerifyInvestmentData', 'BackstageApi', data);
}

//F201 第三頁更新虛擬資產編輯內容查核資料
export function F201_updateVerifyVirtualAssetsData(data) {
  return axioshttp.post('/api/v1/PDISN1011F/updateVerifyVirtualAssetsData', 'BackstageApi', data);
}

//F202 第一頁查詢
export function F202_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISN1021F/SearchN1021FGrid', 'BackstageApi', data);
}
export function F202_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISN1021F/ReSearchN1021FGrid', 'BackstageApi', data);
}

//F202 第二頁比對內容
export function F202_SearchGrid2(data) {
  return axioshttp.post('/api/v1/PDISN1021F/SearchN1022FGrid', 'BackstageApi', data);
}

//F202 更新查核比對結果描述
export function F202_updateVerifyResult(data) {
  return axioshttp.post('/api/v1/PDISN1021F/updateVerifyResult', 'BackstageApi', data);
}

//F202 列印查核比對結果
export function F202_printVerifyResult(data) {
  return axioshttp.post('/api/v1/PDISN1021F/printVerifyResult', 'BackstageApi', data);
}

//F203查詢
export function F203_SearchVerifyConfig(data) {
  return axioshttp.post('/api/v1/PDISN103F/SearchVerifyConfig', 'BackstageApi', data);
}

//F203修改
export function F203_SettingVerifyConfig(data) {
  return axioshttp.post('/api/v1/PDISN103F/SettingVerifyConfig', 'BackstageApi', data);
}

//F204查詢
export function F204_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISN1041F/SearchN1041FGrid', 'BackstageApi', data);
}
export function F204_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISN1041F/ReSearchN1041FGrid', 'BackstageApi', data);
}

//F204明細
export function F204_SearchGrid2(data) {
  return axioshttp.post('/api/v1/PDISN1041F/SearchN1042FGrid', 'BackstageApi', data);
}

//F204明細列印
export function F204_Print(data) {
  return axioshttp.post('/api/v1/PDISN1041F/PrintN1042FGrid', 'BackstageApi', data);
}

//M 取授權年度 && 查調日
export function M_GetAuthOpenTime(data) {
  return axioshttp.get('/api/v1/PDISMBase/GetAuthOpenTime', 'BackstageApi');
}

//M101查詢
export function M101_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISM1011F/SearchM1011FGrid', 'BackstageApi', data);
}
export function M101_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISM1011F/ReSearchM1011FGrid', 'BackstageApi', data);
}

//M101編輯
export function M101_SearchGrid2(data) {
  return axioshttp.post('/api/v1/PDISM1011F/PDISM1012FSearch', 'BackstageApi', data);
}
//M101 刪除授權書
export function M1012_DeleteM1012FFile(data) {
  return axioshttp.post('/api/v1/PDISM1011F/DeleteM1012FFile', 'BackstageApi', data);
}
//M101 新增修改PDISM1012F 家人授權管理
export function M1012_Modify(data) {
  return axioshttp.post('/api/v1/PDISM1011F/Modify1012FGrid', 'BackstageApi', data);
}
//M101 授權動作
export function M1012_UploadFileAuthorize(data) {
  return axioshttp.post('/api/v1/PDISM1011F/UploadFileAuthorize', 'BackstageApi', data);
}
//M101 送審
export function M1012_SendAuth(data) {
  return axioshttp.post('/api/v1/PDISM1011F/SendAuth', 'BackstageApi', data);
}

//M102 退回送審
export function M1012_BackAuth(data) {
  return axioshttp.post('/api/v1/PDISM1011F/BackAuth', 'BackstageApi', data);
}

//M102 查詢
export function M102_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISM1021F/SearchM1021FGrid', 'BackstageApi', data);
}
export function M102_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISM1021F/ReSearchM1021FGrid', 'BackstageApi', data);
}

//M1022 明細查詢
export function M102_SearchGrid2(data) {
  return axioshttp.post('/api/v1/PDISM1021F/SearchPDISM1022FGrid', 'BackstageApi', data);
}

//M103 查詢
export function M103_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISM1031F/SearchM1031FGrid', 'BackstageApi', data);
}
export function M103_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISM1031F/ReSearchM1031FGrid', 'BackstageApi', data);
}
//M103 匯出名單
export function M103_Export(data) {
  return axioshttp.post('/api/v1/PDISM1031F/ExportDetail', 'BackstageApi', data);
}
//M103 傳送至查核平台
export function M103_SendToDipt(data) {
  return axioshttp.post('/api/v1/PDISM1031F/SendToDipt', 'BackstageApi', data);
}

//M103 查核平台結果
export function M103_GetDiptResult(data) {
  return axioshttp.post('/api/v1/PDISM1031F/GetDiptResult', 'BackstageApi', data);
}

//M1032 查詢
export function M103_SearchGrid2(data) {
  return axioshttp.post('/api/v1/PDISM1031F/SearchM1032FGrid', 'BackstageApi', data);
}

//M104查調下拉
export function M104_SearchDropDown(data) {
  return axioshttp.post('/api/v1/PDISM104F/SearchDropDown', 'BackstageApi', data);
}

//M104查詢
export function M104_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISM104F/SearchGrid', 'BackstageApi', data);
}
//M104查詢
export function M104_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISM104F/ReSearchGrid', 'BackstageApi', data);
}

//授權時間管理查詢
export function ModifyAuthOpen(data) {
  return axioshttp.post('/api/v1/PDISM104F/ModifyAuthOpen', 'BackstageApi', data);
}

//M105查詢
export function M105_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISM105F/SearchGrid', 'BackstageApi', data);
}
export function M105_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISM105F/ReSearchGrid', 'BackstageApi', data);
}


//M106取消一次性授權查詢
export function M106_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISM1061F/SearchM1061FGrid', 'BackstageApi', data);
}
export function M106_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISM1061F/ReSearchM1061FGrid', 'BackstageApi', data);
}
//M106取消一次性授權編輯
export function M106_SearchGrid2(data) {
  return axioshttp.post('/api/v1/PDISM1061F/SearchM1062FGrid', 'BackstageApi', data);
}
//M106授權歷程
export function M106_SearchGrid3(data) {
  return axioshttp.post('/api/v1/PDISM1061F/SearchM1063FGrid', 'BackstageApi', data);
}
//M106授權歷程
export function SearchM1063FGridType2(data) {
  return axioshttp.post('/api/v1/PDISM1061F/SearchM1063FGridType2', 'BackstageApi', data);
}
//M106取消授權
export function M106_CancelAuthOne(data) {
  return axioshttp.post('/api/v1/PDISM1061F/CancelAuthOne', 'BackstageApi', data);
}

//S101 代碼類別下拉
export function S101_GetCodeMetadef(data) {
  return axioshttp.post('/api/v1/PDISS101F/GetCodeMetadef', 'BackstageApi', data);
}

//S101 代碼維護查詢
export function S101_SearchCodeMetadefGrid(data) {
  return axioshttp.post('/api/v1/PDISS101F/SearchCodeMetadefGrid', 'BackstageApi', data);
}

//S101 代碼維護新增
export function S101_InsertCodeMetadef(data) {
  return axioshttp.post('/api/v1/PDISS101F/InsertCodeMetadef', 'BackstageApi', data);
}

//S101 代碼檔新增
export function S101_InsertCodeMain(data) {
  return axioshttp.post('/api/v1/PDISS101F/InsertCodeMain', 'BackstageApi', data);
}

//S101 代碼檔更新
export function S101_UpdateCodeMain(data) {
  return axioshttp.post('/api/v1/PDISS101F/UpdateCodeMain', 'BackstageApi', data);
}

//S101 代碼檔刪除
export function S101_DeleteCodeMain(data) {
  return axioshttp.post('/api/v1/PDISS101F/DeleteCodeMain', 'BackstageApi', data);
}

//S101 代碼維護更新
export function S101_UpdateCodeMetadef(data) {
  return axioshttp.post('/api/v1/PDISS101F/UpdateCodeMetadef', 'BackstageApi', data);
}

//S101 代碼維護刪除
export function S101_DeleteCodeMetadef(data) {
  return axioshttp.post('/api/v1/PDISS101F/DeleteCodeMetadef', 'BackstageApi', data);
}


//S101 代碼細項維護查詢
export function S101_SearchCodeMainGrid(data) {
  return axioshttp.post('/api/v1/PDISS101F/SearchCodeMainGrid', 'BackstageApi', data);
}


//S201 階層目錄代碼選單
export function S201_GetDirTypeOption(data) {
  return axioshttp.post('/api/v1/PDISS201F/GetDirTypeOption', 'BackstageApi', data);
}

//S201 查詢階層目錄
export function S201_QueryDirdirectory(data) {
  return axioshttp.post('/api/v1/PDISS201F/QueryDirdirectory', 'BackstageApi', data);
}

//S201 刪除階層目錄
export function S201_RemoveDirdirectory(data) {
  return axioshttp.post('/api/v1/PDISS201F/RemoveDirdirectory', 'BackstageApi', data);
}

//S201 新增階層目錄
export function S201_AddSaveDirdirectory(data) {
  return axioshttp.post('/api/v1/PDISS201F/AddSaveDirdirectory', 'BackstageApi', data);
}

//S201 查詢子目錄
export function S201_QueryDirLayer(data) {
  return axioshttp.post('/api/v1/PDISS201F/QueryDirLayer', 'BackstageApi', data);
}

//S201 更新子目錄名稱
export function S201_EditSaveDirdirectory(data) {
  return axioshttp.post('/api/v1/PDISS201F/EditSaveDirdirectory', 'BackstageApi', data);
}


//S201 刪除子目錄
export function S201_RemoveDirLayer(data) {
  return axioshttp.post('/api/v1/PDISS201F/RemoveDirLayer', 'BackstageApi', data);
}

//S201 更新子目錄
export function S201_EditSaveDirLayer(data) {
  return axioshttp.post('/api/v1/PDISS201F/EditSaveDirLayer', 'BackstageApi', data);
}

//S201 新增子目錄
export function S201_AddSaveDirLayer(data) {
  return axioshttp.post('/api/v1/PDISS201F/AddSaveDirLayer', 'BackstageApi', data);
}


//S202 系統類別下拉選單
export function S202_GetDirTypeOption(data) {
  return axioshttp.post('/api/v1/PDISS202F/GetDirTypeOption', 'BackstageApi', data);
}

//S202 系統功能目錄下拉選單
export function S202_GetDirdirectoryOption(data) {
  return axioshttp.post('/api/v1/PDISS202F/GetDirdirectoryOption', 'BackstageApi', data);
}


//S202 系統功能目錄下拉選單
export function S202_GetDirLayerOption(data) {
  return axioshttp.post('/api/v1/PDISS202F/GetDirLayerOption', 'BackstageApi', data);
}


//S202 程式類別下拉選單
export function S202_GetPrgTypeOption(data) {
  return axioshttp.post('/api/v1/PDISS202F/GetPrgTypeOption', 'BackstageApi', data);
}

//S202 查詢
export function S202_QueryProgram(data) {
  return axioshttp.post('/api/v1/PDISS202F/QueryProgram', 'BackstageApi', data);
}

//S202 編
export function S202_EditProgram(data) {
  return axioshttp.post('/api/v1/PDISS202F/EditProgram', 'BackstageApi', data);
}


//S202 insert
export function S202_AddSaveProgram(data) {
  return axioshttp.post('/api/v1/PDISS202F/AddSaveProgram', 'BackstageApi', data);
}


//S202 update
export function S202_EditSaveProgram(data) {
  return axioshttp.post('/api/v1/PDISS202F/EditSaveProgram', 'BackstageApi', data);
}


//S202 delete
export function S202_RemoveProgram(data) {
  return axioshttp.post('/api/v1/PDISS202F/RemoveProgram', 'BackstageApi', data);
}

//S203 查詢
export function S203_QueryGrid(data) {
  return axioshttp.post('/api/v1/PDISS203F/QueryGrid', 'BackstageApi', data);
}
export function S203_ReQueryGrid(data) {
  return axioshttp.post('/api/v1/PDISS203F/ReQueryGrid', 'BackstageApi', data);
}

//S203 編
export function S203_EditData(data) {
  return axioshttp.post('/api/v1/PDISS203F/EditData', 'BackstageApi', data);
}

//S203 delete
export function S203_RemoveData(data) {
  return axioshttp.post('/api/v1/PDISS203F/RemoveData', 'BackstageApi', data);
}

//S203 insert
export function S203_AddSaveData(data) {
  return axioshttp.post('/api/v1/PDISS203F/AddSaveData', 'BackstageApi', data);
}

//S203 update
export function S203_EditSaveData(data) {
  return axioshttp.post('/api/v1/PDISS203F/EditSaveData', 'BackstageApi', data);
}

//S203 第二頁選單查詢
export function S203_QueryProgOption(data) {
  return axioshttp.post('/api/v1/PDISS203F/QueryProgOption', 'BackstageApi', data);
}


//S301 使用者帳號維護
export function S301_Query(data) {
  return axioshttp.post('/api/v1/PDISS301F/Query', 'BackstageApi', data);
}

//S301 使用者帳號存檔
export function S301_Modify(data) {
  return axioshttp.post('/api/v1/PDISS301F/Modify', 'BackstageApi', data);
}
//Base 角色群組
export function SearchGridOnRoleSeq() {
  return axioshttp.post('/api/v1/Base/SearchGridOnRoleSeq', 'BackstageApi');
}

//S302 使用者密碼變更
export function S302_Modify(data) {
  return axioshttp.post('/api/v1/PDISS302F/Modify', 'BackstageApi', data);
}
//S303 忘記密碼
export function S303_Modify(data) {
  return axioshttp.post('/api/v1/PDISS303F/Modify', 'BackstageApi', data);
}

//S304 查詢
export function S304_QueryGrid(data) {
  return axioshttp.post('/api/v1/PDISS304F/QueryGrid', 'BackstageApi', data);
}
export function S304_ReQueryGrid(data) {
  return axioshttp.post('/api/v1/PDISS304F/ReQueryGrid', 'BackstageApi', data);
}

//S304 刪除
export function S304_Remove(data) {
  return axioshttp.post('/api/v1/PDISS304F/Remove', 'BackstageApi', data);
}

//S304 新增
export function S304_AddSave(data) {
  return axioshttp.post('/api/v1/PDISS304F/AddSave', 'BackstageApi', data);
}

//S304 編
export function S304_Edit(data) {
  return axioshttp.post('/api/v1/PDISS304F/Edit', 'BackstageApi', data);
}

//S304 更新
export function S304_EditSave(data) {
  return axioshttp.post('/api/v1/PDISS304F/EditSave', 'BackstageApi', data);
}

//S305 查詢
export function S305_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISS305F/SearchGrid', 'BackstageApi', data);
}
export function S305_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISS305F/ReSearchGrid', 'BackstageApi', data);
}
//S305 刪除
export function S305_Delete(data) {
  return axioshttp.post('/api/v1/PDISS305F/Delete', 'BackstageApi', data);
}
//S305 詳細
export function S305_Detail(data) {
  return axioshttp.post('/api/v1/PDISS305F/Detail', 'BackstageApi', data);
}
//S305 新增存檔
export function S305_DetailAddSave(data) {
  return axioshttp.post('/api/v1/PDISS305F/DetailAddSave', 'BackstageApi', data);
}
//S305 修改存檔
export function S305_DetailEditSave(data) {
  return axioshttp.post('/api/v1/PDISS305F/DetailEditSave', 'BackstageApi', data);
}
//S305 修改密碼存檔
export function S305_DetailEditPwSave(data) {
  return axioshttp.post('/api/v1/PDISS305F/DetailEditPwSave', 'BackstageApi', data);
}
//S305 修改狀態存檔
export function S305_DetailEditFlagSave(data) {
  return axioshttp.post('/api/v1/PDISS305F/DetailEditFlagSave', 'BackstageApi', data);
}

//S306 修改
export function S306_Modify(data) {
  return axioshttp.post('/api/v1/PDISS306F/Modify', 'BackstageApi', data);
}

//S401 查詢
export function S401_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISS401F/SearchGrid', 'BackstageApi', data);
}
export function S401_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISS401F/ReSearchGrid', 'BackstageApi', data);
}
//S401 刪除
export function S401_Delete(data) {
  return axioshttp.post('/api/v1/PDISS401F/Delete', 'BackstageApi', data);
}
//S401 詳細
export function S401_Detail(data) {
  return axioshttp.post('/api/v1/PDISS401F/Detail', 'BackstageApi', data);
}
//S401 新增存檔
export function S401_DetailAddSave(data) {
  return axioshttp.post('/api/v1/PDISS401F/DetailAddSave', 'BackstageApi', data);
}
//S401 修改存檔
export function S401_DetailEditSave(data) {
  return axioshttp.post('/api/v1/PDISS401F/DetailEditSave', 'BackstageApi', data);
}
//S401 匯入
export function S401_Import(data) {
  return axioshttp.post('/api/v1/PDISS401F/Import', 'BackstageApi', data);
}
//S402 查詢
export function S402_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISS402F/SearchGrid', 'BackstageApi', data);
}
//S402 刪除
export function S402_Delete(data) {
  return axioshttp.post('/api/v1/PDISS402F/Delete', 'BackstageApi', data);
}
//S402 詳細
export function S402_Detail(data) {
  return axioshttp.post('/api/v1/PDISS402F/Detail', 'BackstageApi', data);
}
//S402 新增存檔
export function S402_DetailAddSave(data) {
  return axioshttp.post('/api/v1/PDISS402F/DetailAddSave', 'BackstageApi', data);
}
//S402 修改存檔
export function S402_DetailEditSave(data) {
  return axioshttp.post('/api/v1/PDISS402F/DetailEditSave', 'BackstageApi', data);
}
//S406 查詢
export function S406_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISS406F/SearchGrid', 'BackstageApi', data);
}
//S406 查詢
export function S406_SearchQaclassMaxOrd(data) {
  return axioshttp.post('/api/v1/PDISS406F/SearchQaclassMaxOrd', 'BackstageApi', data);
}
//S406 刪除
export function S406_Delete(data) {
  return axioshttp.post('/api/v1/PDISS406F/Delete', 'BackstageApi', data);
}
//S406 詳細
export function S406_Detail(data) {
  return axioshttp.post('/api/v1/PDISS406F/Detail', 'BackstageApi', data);
}
//S406 新增存檔
export function S406_DetailAddSave(data) {
  return axioshttp.post('/api/v1/PDISS406F/DetailAddSave', 'BackstageApi', data);
}
//S406 修改存檔
export function S406_DetailEditSave(data) {
  return axioshttp.post('/api/v1/PDISS406F/DetailEditSave', 'BackstageApi', data);
}
//S406 刪除
export function S406_DeleteQa(data) {
  return axioshttp.post('/api/v1/PDISS406F/DeleteQa', 'BackstageApi', data);
}
//S406 詳細
export function S406_DetailQa(data) {
  return axioshttp.post('/api/v1/PDISS406F/DetailQa', 'BackstageApi', data);
}
//S406 新增存檔
export function S406_DetailQaAddSave(data) {
  return axioshttp.post('/api/v1/PDISS406F/DetailQaAddSave', 'BackstageApi', data);
}
//S406 修改存檔
export function S406_DetailQaEditSave(data) {
  return axioshttp.post('/api/v1/PDISS406F/DetailQaEditSave', 'BackstageApi', data);
}
//S406 取得下拉
export function S406_SearchQaclass(data) {
  return axioshttp.post('/api/v1/PDISS406F/SearchQaclass', 'BackstageApi', data);
}
//S404 查詢
export function S404_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISS404F/SearchGrid', 'BackstageApi', data);
}
export function S404_ReSearchGrid(data) {
  return axioshttp.post('/api/v1/PDISS404F/ReSearchGrid', 'BackstageApi', data);
}
//S404 刪除
export function S404_Delete(data) {
  return axioshttp.post('/api/v1/PDISS404F/Delete', 'BackstageApi', data);
}
//S404 詳細
export function S404_Detail(data) {
  return axioshttp.post('/api/v1/PDISS404F/Detail', 'BackstageApi', data);
}
//S404 新增存檔
export function S404_DetailAddSave(data) {
  return axioshttp.post('/api/v1/PDISS404F/DetailAddSave', 'BackstageApi', data);
}
//S404 修改存檔
export function S404_DetailEditSave(data) {
  return axioshttp.post('/api/v1/PDISS404F/DetailEditSave', 'BackstageApi', data);
}

//S601 查詢
export function S601_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISS601F/SearchGrid', 'BackstageApi', data);
}

//S602 查詢
export function S602_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISS602F/SearchGrid', 'BackstageApi', data);
}

//S602 查詢
export function S603_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISS603F/SearchGrid', 'BackstageApi', data);
}


//S701 查詢
export function S701_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISS701F/Search701FGrid', 'BackstageApi', data);
}

//S701 明細查詢
export function S701_SearchGridDetail(data) {
  return axioshttp.post('/api/v1/PDISS701F/Search701FGridDetail', 'BackstageApi', data);
}

//S701 更新排程
export function S701_ModifyGrid(data) {
  return axioshttp.post('/api/v1/PDISS701F/Modify701FGrid', 'BackstageApi', data);
}

//S701 排程執行
export function S701_BattRun(data) {
  return axioshttp.post('/api/v1/PDISS701F/BattRun', 'BackstageApi', data);
}

//S701 更新排程明細
export function S701_ModifyGridDetail(data) {
  return axioshttp.post('/api/v1/PDISS701F/Modify701FGridDetail', 'BackstageApi', data);
}

//S702 查詢
export function S702_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISS702F/Search702FGrid', 'BackstageApi', data);
}

//S703 查詢
export function S703_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISS703F/Search703FGrid', 'BackstageApi', data);
}

//D101 應申報人員名單
export function D101_Print(data) {
  return axioshttp.post('/api/v1/PDISD101R/Print', 'BackstageApi', data);
}
//D103 N日後逾期申報人員表
export function D103_Print(data) {
  return axioshttp.post('/api/v1/PDISD103R/Print', 'BackstageApi', data);
}
//D108 財產申報案件管理一覽表
export function D108_Print(data) {
  return axioshttp.post('/api/v1/PDISD108R/Print', 'BackstageApi', data);
}
//D201 申報類別勾選錯誤名單
export function D201_Print(data) {
  return axioshttp.post('/api/v1/PDISD201R/Print', 'BackstageApi', data);
}
//D202 卸離職_解除代理(兼任)申報日與卸離職日不符名單
export function D202_Print(data) {
  return axioshttp.post('/api/v1/PDISD202R/Print', 'BackstageApi', data);
}
//D203 申報日非於申報期間名單
export function D203_Print(data) {
  return axioshttp.post('/api/v1/PDISD203R/Print', 'BackstageApi', data);
}
//D204 一年以上不須申報人員名單
export function D204_Print(data) {
  return axioshttp.post('/api/v1/PDISD204R/Print', 'BackstageApi', data);
}
//監察院


//取縣市下拉
export function GetCityCountryDropDownMenu(data) {
  return axioshttp.get('/api/v1/BackEndReportingForm/GetCityCountryDropDownMenu', 'BackEndService', data);
}

//B201 查詢
export function B201_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISB201F/SearchGrid', 'BackstageApi', data);
}

//B201 查詢服務機關
export function B201_SearchDxServiceUnits(data) {
  return axioshttp.post('/api/v1/PDISB201F/SearchDxServiceUnits', 'BackstageApi', data);
}

//B201 更新服務機關
export function B201_UpdateDxServiceUnits(data) {
  return axioshttp.post('/api/v1/PDISB201F/UpdateDxServiceUnits', 'BackstageApi', data);
}

export function B201_UpdateMain(data) {
  return axioshttp.post('/api/v1/PDISB201F/UpdateMain', 'BackstageApi', data);
}

//B201 查詢
export function B202_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISB202F/SearchGrid', 'BackstageApi', data);
}

//B202 刪除
export function B202_Delete(data) {
  return axioshttp.post('/api/v1/PDISB202F/Delete', 'BackstageApi', data);
}

//B203 查詢
export function B203_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISB203F/SearchGrid', 'BackstageApi', data);
}

//B203 列印
export function B203_print(data) {
  return axioshttp.post('/api/v1/PDISB203F/print', 'BackstageApi', data);
}

//M201查調日期
export function M201_SearchAuthOpen() {
  return axioshttp.post('/api/v1/PDISM201F/SearchAuthOpen', 'BackstageApi');
}

//M201 列印 查核匯入_派查檔 Authorize
export function M201_PrintAuth(data) {
  return axioshttp.post('/api/v1/PDISM201F/PrintAuth', 'BackstageApi', data);
}

//M201 列印 查核匯入_查調名單 Authorize_Detail
export function M201_PrintAuthDetail(data) {
  return axioshttp.post('/api/v1/PDISM201F/PrintAuthDetail', 'BackstageApi', data);
}
//M201 查調總人數
export function M201_CountAuth(data) {
  return axioshttp.post('/api/v1/PDISM201F/CountAuth', 'BackstageApi', data);
}


//M205查詢
export function M205_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISM205F/SearchGrid', 'BackstageApi', data);
}


//S314 查詢
export function S314_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISS314F/SearchGrid', 'BackstageApi', data);
}

//S314 刪除
export function S314_Remove(data) {
  return axioshttp.post('/api/v1/PDISS314F/Remove', 'BackstageApi', data);
}

//S314 新增
export function S314_AddSave(data) {
  return axioshttp.post('/api/v1/PDISS314F/AddSave', 'BackstageApi', data);
}

//S314 更新
export function S314_EditSave(data) {
  return axioshttp.post('/api/v1/PDISS314F/EditSave', 'BackstageApi', data);
}


//S315 查詢
export function S315_SearchGrid(data) {
  return axioshttp.post('/api/v1/PDISS315F/SearchGrid', 'BackstageApi', data);
}

//Base 角色群組
export function SearchCyGridOnRoleSeq() {
  return axioshttp.post('/api/v1/Base/SearchCyGridOnRoleSeq', 'BackstageApi');
}

//S315 新增
export function S315_DetailAddSave(data) {
  return axioshttp.post('/api/v1/PDISS315F/DetailAddSave', 'BackstageApi', data);
}

//S315 更新
export function S315_DetailEditSave(data) {
  return axioshttp.post('/api/v1/PDISS315F/DetailEditSave', 'BackstageApi', data);
}

//S315 變更密碼
export function S315_DetailEditPwSave(data) {
  return axioshttp.post('/api/v1/PDISS315F/DetailEditPwSave', 'BackstageApi', data);
}

//S315 帳號解鎖
export function S315_DetailEditFlagSave(data) {
  return axioshttp.post('/api/v1/PDISS315F/DetailEditFlagSave', 'BackstageApi', data);
}

//S315 刪除
export function S315_Delete(data) {
  return axioshttp.post('/api/v1/PDISS315F/Delete', 'BackstageApi', data);
}


//////下載舊系統紙本申報////////

//GetLandDropDownMenu
export function UploadReportOld(data) {
  // return axioshttp.post('/api/v1/PDISB101F/UploadReportOld', 'UploadApi' , data);
  return axioshttp.post('/api/v1/PDISB101F/UploadReportOld', 'BackstageApi', data);
}


//2025-02-20新增寫LOG
export function USR_ACT_LOG(data) {
  return axioshttp.post('/api/v1/Base/WriteUserActLog', 'BackstageApi', data);
}